import { callApi } from 'helpers/saga-helpers';
import {
  setExpertiseMissions,
  requestExpertiseMissions,
  setClaimInfo,
} from 'containers/CourtManagerAssignedExpertise/actions';
import { takeLeading, put } from '@redux-saga/core/effects';
import {
  REQUEST_EXPERTISE_MISSIONS,
  REQUEST_UPDATE_MISSION_MANAGER,
  REQUEST_GET_CLAIM_INFO,
} from 'containers/CourtManagerAssignedExpertise/constants';
import accessTokenStorage from 'containers/services/security/access-token-storage';
export function* fetchExpertiseMessions(action: any) {
  const path = `/corporeal/mission`;
  const token = accessTokenStorage.get().token;

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, [], options, [], setExpertiseMissions);
}

export function* fetchExpertiseMissionsSaga() {
  yield takeLeading(REQUEST_EXPERTISE_MISSIONS, fetchExpertiseMessions);
}
export function* makeRequestUpdateMission(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const token = accessTokenStorage.get().token;
  const path = `/corporeal/mission/change-mission`;

  const options = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ...payload }),
  };

  const errorResponse = yield callApi(path, {}, options);

  /* istanbul ignore next */
  if (!errorResponse) {
    yield successCallback();
    yield put(requestExpertiseMissions([]));
  }
}

export function* requestUpdateMissionSaga() {
  yield takeLeading(REQUEST_UPDATE_MISSION_MANAGER, makeRequestUpdateMission);
}
export function* makeRequestClaimInfo(action: any) {
  const { payload } = action;
  const path = `/corporeal/common/get-claim-info?claimId=${payload.claimId}`;
  const token = accessTokenStorage.get().token;

  const options = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  };

  yield callApi(path, [], options, [], setClaimInfo);
}
export function* requestRequestClaimInfoSaga() {
  yield takeLeading(REQUEST_GET_CLAIM_INFO, makeRequestClaimInfo);
}
export default [
  fetchExpertiseMissionsSaga,
  requestUpdateMissionSaga,
  requestRequestClaimInfoSaga,
];
